
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedClosedLeft as ObiThreewayStackedClosedLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-closed-left.js';
 
 
 

 
 export const ObiThreewayStackedClosedLeft = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-closed-left',
   elementClass: ObiThreewayStackedClosedLeftElement,
   events: {
     
   }
  });
 
 